// 공중계정(gzh) 관련 공용 상수 — FollowerList.vue / FollowerStats.vue 양쪽에서 사용한다.
// SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 팔로우: 이전에는 두 화면에 값이 각각 로컬 복제되어
// 있었으나(중복), 멀티테넌트 개선 작업(2026-07-24)에서 단일 출처로 추출했다.

// gzh-options의 gzhName(논리명) → 중국어 표시 라벨 매핑. 매핑에 없는 gzhName은
// 호출부가 BE가 내려준 option.label로 폴백해야 한다.
export const GZH_LABEL_MAP = {
  'dentium-china-dyh': '登腾',
  'dentalmax-china-dyh': '登泰美',
  'certilife-gzh': '信徕安',
};

// 공중계정 유형 배지 — wechatauths엔 유형 필드가 없어 FE 매핑 상수로 부착.
export const GZH_TYPE_MAP = {
  'dentium-china-dyh': 'sub',
  'dentalmax-china-dyh': 'sub',
  'certilife-gzh': 'svc',
};

// 필터 드롭다운 노출 순서 — 信徕安(플랫폼) → 登腾(덴티움) → 登泰美(덴탈맥스).
export const GZH_ORDER = ['certilife-gzh', 'dentium-china-dyh', 'dentalmax-china-dyh'];
